import axios from "../axios-auth";
import orginal_axios from "axios";

export const customerService = {
    getCustomers,
    saveCustomer,
    getCustomerDetail,
    getAllCustomer,
    saveCustomerExcel,
    getAllCustomers,
    getCustomerExcelTemplate,
    getCustomerExcelExport,
    getLastCustomer,
};

function getCustomers(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.township) {
        params["township"] = searchParams.township;
    }

    if (searchParams.creditLevelId) {
        params["creditLevelId"] = searchParams.creditLevelId;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    if (searchParams.email) {
        params["email"] = searchParams.email;
    }

    if (searchParams.saleTeamId) {
        params["saleTeamId"] = searchParams.saleTeamId;
    }

    if (typeof (searchParams.isNoRegion) == 'boolean') {
        params["isNoRegion"] = searchParams.isNoRegion;
    }

    return axios.get("/auth/customers", { params });
}

function getAllCustomer(searchParams) {
    let params = {
        sort: "code,asc"
    };
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.township) {
        params["township"] = searchParams.township;
    }

    if (searchParams.creditLevelId) {
        params["creditLevelId"] = searchParams.creditLevelId;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    if (typeof (searchParams.isNoRegion) == 'boolean') {
        params["isNoRegion"] = searchParams.isNoRegion;
    }
    return axios.get("/auth/customers", { params });
}

function saveCustomer(customer) {
    if (!customer.id) {
        // new customer
        return axios.post("/auth/customer", customer);
    } else {
        // edit
        return axios.put("/auth/customer", customer);
    }
}

function getCustomerDetail(id) {
    return axios.get("/auth/customer/" + id);
}

function saveCustomerExcel(file) {
    return axios.post('/auth/customer-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function getAllCustomers() {
    return axios.get("/auth/all-customer");
}

function getCustomerExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/customer-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getCustomerExcelExport(searchParams) {
    let params = {
    };
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.township) {
        params["township"] = searchParams.township;
    }

    if (searchParams.creditLevelId) {
        params["creditLevelId"] = searchParams.creditLevelId;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    if (typeof (searchParams.isNoRegion) == 'boolean') {
        params["isNoRegion"] = searchParams.isNoRegion;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/customer-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getLastCustomer() {
    return axios.get("/auth/last-customer");
}
